export const getAvailablePorts = (cruiseLine, cruiseAddress) => {
  if (!cruiseLine || !cruiseAddress) return [];

  const filteredPorts = cruiseLine.cruise_ports.filter(
    port => {
      // if no country code, allow it
      if(!cruiseAddress?.country_code) return true;
      // otherwise only return ports in the same country
      return port.address?.country_code === cruiseAddress?.country_code
    }
  );
    
  // Remove duplicates based on name field
  const uniquePorts = filteredPorts.filter((port, index, array) => 
    array.findIndex(p => p.name === port.name) === index
  );
  // Sort ports alphabetically by name
  const sortedPorts = uniquePorts.sort((a, b) => a.name.localeCompare(b.name));
  return sortedPorts;
};
